module.exports = __webpack_public_path__ + "static/media/signin.b30ec50b.svg";